// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"5be49b04","453":"170a89b0","777":"c748db3a"}[chunkId] + ".chunk.js";
};